import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { NativeElementInjectorDirective } from './directives/native-element-injector.directive';
import { NgxIntlTelInputComponent } from './ngx-intl-tel-input.component';

export const dropdownModuleForRoot: ModuleWithProviders<BsDropdownModule> = BsDropdownModule.forRoot();

@NgModule({
  declarations: [NgxIntlTelInputComponent, NativeElementInjectorDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, dropdownModuleForRoot, NgxTrimDirectiveModule],
  exports: [NgxIntlTelInputComponent, NativeElementInjectorDirective]
})
export class NgxIntlTelInputModule {}
